export enum ProfileStatus {
  PROFILE_UNSET, // Do not use, needed because of proto3 limitations
  PROFILE_ACTIVATED,
  PROFILE_BLOCKED,
  PROFILE_DEACTIVATED,
}
